import React, { useEffect, useState } from 'react';

const bannerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '10px 16px',
    background: '#b71c1c',
    color: '#fff',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: '14px',
    fontWeight: 500,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    pointerEvents: 'none',
};

const iconStyle = {
    fontSize: '16px',
    lineHeight: 1,
};

/**
 * Global offline banner — mount once in App.js.
 * Uses browser online/offline events; no API or MUI dependency.
 */
const NetworkStatus = () => {
    const [offline, setOffline] = useState(
        typeof navigator !== 'undefined' ? !navigator.onLine : false,
    );

    useEffect(() => {
        const goOffline = () => setOffline(true);
        const goOnline = () => setOffline(false);

        /**
         * `navigator.onLine` stays the primary signal — it is what actually
         * reports a pulled cable or dropped Wi-Fi, and it must not be second
         * guessed. An earlier attempt verified it with a same-origin request
         * before showing the banner, which BROKE real offline detection: the
         * probe hit the app's own server, and in development that is localhost,
         * which answers happily with the internet unplugged.
         *
         * `api-reachable` is the one addition. invokeApi fires it after every
         * completed round trip to the API — a real response from a real remote
         * host, which is genuine proof of connectivity. It exists only so a
         * banner that went up wrongly can come back down; nothing suppresses the
         * banner before it is shown.
         */
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        window.addEventListener('api-reachable', goOnline);

        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
            window.removeEventListener('api-reachable', goOnline);
        };
    }, []);

    if (!offline) return null;

    return (
        <div style={bannerStyle} role="alert">
            <span style={iconStyle} aria-hidden="true">⚠</span>
            <span>You&apos;re offline — check your internet connection</span>
        </div>
    );
};

export default NetworkStatus;
